/**
 * @file IndividualsReportParameters.js
 * @description Individuals report parameter controls used by GenerateReportPage.
 */

import { SearchableDropdown } from '../helpers/SearchableDropdown';
import { getText } from '../../i18n';

function getSavedOptions(options, selectedIds) {
    const selectedIdSet = new Set((selectedIds || []).map(String));
    return (options || []).filter(option =>
        selectedIdSet.has(String(option.id)),
    );
}

function IndividualsReportParameters({
    isReadOnlyMode,
    individualParameterOptions,
    individualParameters,
    handleIndividualsParameterChange,
}) {
    return (
        <div
            style={{
                width: '100%',
                margin: '0 auto',
                display: 'grid',
                gap: '40px',
            }}
        >
            <div>
                <div
                    className="file-form-label"
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_c869672b9f14')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_ac7533a67d32')}
                    options={individualParameterOptions.populationGroups}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handleIndividualsParameterChange(
                            'populationGroups',
                            selectedOptions,
                        )
                    }
                    savedOptions={getSavedOptions(
                        individualParameterOptions.populationGroups,
                        individualParameters.populationGroups,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
            <div>
                <div
                    className="file-form-label"
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_a3c686e711e4')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_4d18568c50da')}
                    options={individualParameterOptions.categories}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handleIndividualsParameterChange(
                            'categories',
                            selectedOptions,
                        )
                    }
                    savedOptions={getSavedOptions(
                        individualParameterOptions.categories,
                        individualParameters.categories,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
            <div>
                <div
                    className="file-form-label"
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_9845e4c7cbf9')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_b544b72e718a')}
                    options={individualParameterOptions.employmentStatuses}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handleIndividualsParameterChange(
                            'employmentStatuses',
                            selectedOptions,
                        )
                    }
                    savedOptions={getSavedOptions(
                        individualParameterOptions.employmentStatuses,
                        individualParameters.employmentStatuses,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
            <div>
                <div
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_6e702cb4e0c7')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_ee7387e7237b')}
                    options={individualParameterOptions.accountStatuses}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handleIndividualsParameterChange(
                            'accountStatuses',
                            selectedOptions,
                        )
                    }
                    savedOptions={getSavedOptions(
                        individualParameterOptions.accountStatuses,
                        individualParameters.accountStatuses,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
        </div>
    );
}

export default IndividualsReportParameters;
